/* eslint-disable no-underscore-dangle */
import { configureStore as configureReduxStore } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';
import rootReducer from 'reducers';
import lcrSaga from 'sagas';

const sagaMiddleware = createSagaMiddleware();

const isReduxDevToolsAvailable = process.env.NODE_ENV !== 'production'
  && typeof window.__REDUX_DEVTOOLS_EXTENSION__ === 'function';

if (process.env.NODE_ENV === 'production' && typeof window.__REACT_DEVTOOLS_GLOBAL_HOOK__ === 'object') {
  const keys = Object.keys(window.__REACT_DEVTOOLS_GLOBAL_HOOK__);

  for (let i = 0; i < keys.length; i++) {
    const key = keys[i];

    if (typeof window.__REACT_DEVTOOLS_GLOBAL_HOOK__[key] === 'function') {
      window.__REACT_DEVTOOLS_GLOBAL_HOOK__[key] = () => {};
    } else {
      window.__REACT_DEVTOOLS_GLOBAL_HOOK__[key] = null;
    }
  }
}

export default function configureStore(preloadedState) {
  const store = configureReduxStore({
    reducer: rootReducer,
    preloadedState,
    middleware: getDefaultMiddleware => getDefaultMiddleware({
      // Legacy state contains non-serializable values (e.g. liveplayer.liveplayerInstance).
      // Re-enable per-path once slices are migrated.
      serializableCheck: false,
      // Legacy reducers/sagas may mutate state. Classic createStore did not check this.
      immutableCheck: false,
    }).concat(sagaMiddleware),
    devTools: isReduxDevToolsAvailable,
  });

  sagaMiddleware.run(lcrSaga);

  if (module.hot) {
    module.hot.accept('../reducers', () => {
      import('reducers').then(({ default: nextRootReducer }) => {
        store.replaceReducer(nextRootReducer);
      });
    });
  }

  return store;
}
